export interface SalesOrderLineAllocationsSummaryTop {
  salesOrderAndLineNo: string;
  productId: string;
  productKey: string;
  productDescription: string;
  quantity: number;
  allocated: number;
  picked: number;
  currencySymbol: string;
  price: number;
  deliveryDate: Date;
}
